import type { ReactNode } from 'react';
import type { SessionComponentBadges } from '@lp/shared';
import {
  ClipboardList,
  FileText,
  ListChecks,
  MousePointerClick,
  PlayCircle,
  Presentation,
} from 'lucide-react';
import { Badge } from '../ui.js';

const ORDER = ['video', 'deck', 'notes', 'interactive', 'quiz', 'assignment'] as const;

const META: Record<(typeof ORDER)[number], { label: string; icon: ReactNode }> = {
  video: { label: 'Video', icon: <PlayCircle size={12} aria-hidden /> },
  deck: { label: 'Deck', icon: <Presentation size={12} aria-hidden /> },
  notes: { label: 'Notes', icon: <FileText size={12} aria-hidden /> },
  interactive: { label: 'Interactive', icon: <MousePointerClick size={12} aria-hidden /> },
  quiz: { label: 'Quiz', icon: <ListChecks size={12} aria-hidden /> },
  assignment: { label: 'Assignment', icon: <ClipboardList size={12} aria-hidden /> },
};

/** What is inside a session. Only the parts that exist are listed. */
export function ComponentBadges({ components }: { components: SessionComponentBadges }) {
  const present = ORDER.filter((key) => components[key]);
  if (!present.length) return null;

  return (
    <ul className="flex flex-wrap items-center gap-1.5" aria-label="What this session contains">
      {present.map((key) => (
        <li key={key}>
          <Badge icon={META[key].icon}>{META[key].label}</Badge>
        </li>
      ))}
    </ul>
  );
}
